

/** @type {import('./min')} */
module.exports = Math.min;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/min.js
// module id = ../node_modules/math-intrinsics/min.js
// module chunks = 0